<script lang="ts">
    import {t} from "i18next";
    import {onMount} from "svelte";
    import {staticRoot} from "@src/appStore";

    export const androidAppStoreImageIsoCodes = [
        "af", "am", "ar", "az", "be", "bg", "bn", "bs", "ca", "cs", "da", "de", "el", "en",
        "es-LA", "es", "et", "eu", "fa", "fi", "fr-CA", "fr", "gl", "gu", "he", "hi", "hr",
        "hu", "hy", "id", "is", "it", "ja", "ka", "kk", "km", "kn", "ko", "ky", "lo", "lt",
        "lv", "mk", "ml", "mn", "mr", "ms", "my", "ne", "nl", "no", "pa", "pl", "pt-BR",
        "pt-PT", "ro", "ru", "si", "sk", "sl", "sq", "sr", "sv", "sw", "ta", "te", "th",
        "tl", "tr", "uk", "ur", "uz", "vi", "zh-CN", "zh-HK", "zh-TW", "zu"
    ];
    let langCode: string | undefined;

    onMount(() => {
        langCode = (() => {
            const browserLang = document.documentElement.lang;
            // There is a direct match
            if (browserLang in androidAppStoreImageIsoCodes) {
                return browserLang;
            }
            // Try to match primary code
            let primary = browserLang.slice(0, 2);
            if (primary.length !== 2) {
                throw new Error(`Android app store badge translation lookup error. Expected ${primary} to be two characters.`);
            }
            // Iterate through the list and find the first matching code
            for (const code of androidAppStoreImageIsoCodes) {
                if (code.startsWith(primary)) {
                    return code;
                }
            }
            // Fall back to English if all else fails
            return "en";
        })();
    })


</script>

{#if langCode}
    <a href="#">
        <img src={`${$staticRoot}/images/app-store/android/badge-${langCode}.png`}
             alt={t("android_app_alt_tag")}
             height={40}
             width={135}
        />
    </a>
{/if}